import { acquisitionErrorContext } from "@litres/errors";

export const externalReferralError =
  acquisitionErrorContext.feature("ExternalReferral");
